export default __webpack_public_path__ + "f0d046b4086243049c67966a7ad137eb.ttf";